import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Article from "../../../components/CommonCompnents/resourcePage/Article";
import VideoBanner from "../../../components/CommonCompnents/resourcePage/VideoBanner";
import Video from "../../../components/CommonCompnents/resourcePage/Video";

import controlTrade from "../../../assets/images/trading-control.svg";
import learnTrade from "../../../assets/images/offerings.svg";
import python from "../../../assets/images/python.svg";
import node from "../../../assets/images/node.svg";
import java from "../../../assets/images/java.svg";
import OfferSection from "../../../components/CommonCompnents/Home/OfferSection";
import {
  GetAccecssTitle,
  GetAccessHome,
  Offers,
  OfferTitle,
  ResourceObject,
} from "../../Constants/commenFeatures";
import "../../../assets/scss/components/home.scss";
import Footer from "../Footer";
import { MyAuthContext } from "../../../Context/AuthContext";
import InputField from "../../../components/generic/inputField";
import { signFormSubmit } from "../../../services/Signup/SignupApiServices";
import debounce from "../../../components/utils/debounce";
import {
  alphabetExp,
  betweenNChars,
  emailRegex,
  integerExp,
  phoneNo,
} from "../../../components/utils/regex";
import { AGetCities } from "../../../services/login/loginApiService";
import Autocomplete from "../../../components/generic/autocomplete";
import { getFaqs } from "../../../services/Faqs&Resourse/faqsServices";
import { getResoucesContent } from "../../../services/Faqs&Resourse/resource";
import { fnBrowserDetect, getDevice } from "../../../services/genralServise";

import {
  removeServerErrors,
  constants,
  slicedData,
} from "../../Constants/commenFeatures";
import GetAccess from "../../../components/CommonCompnents/Home/GetAccess";
import urlConfig, { config } from "../../../config/domain";

const Home = () => {
  const authContext = useContext(MyAuthContext);
  const [faqs, setFaqs] = useState({
    faqData: "",
    faqId: "",
  });

  const [resouces, setResouces] = useState({
    articles: [],
    videos: [],
  });

  const [cities, setCities] = useState(null);
  const [signupFormVal, setSignupFormVal] = useState({
    nm: "",
    eml: "",
    phNo: "",
    city: "",
    state: "",
    submitedBy: "Individual",
    // compName: "",
  });
  const [isServerErr, setIsServerErr] = useState({
    isSuccess: "",
    isRejected: "",
  });

  const [signupErr, setSignupErr] = useState({
    nm: undefined,
    eml: undefined,
    phNo: undefined,
    city: undefined,
    compName: undefined,
  });

  const getFaqsRes = (res) => {
    if (res && res.data) {
      setFaqs({
        faqId: res.data.clntFaq.qa[0].id,
        faqData: slicedData(
          res.data.clntFaq.qa,
          constants.MinFaqs,
          constants.MaxFaqs
        ),
      });
    }
  };

  const submitSignupFormRes = (res) => {
    if (res && res.data) {
      setIsServerErr({
        ...isServerErr,
        isSuccess:
          "Your request for call has been submitted. We will get back to you shortly.",
      });
      setCities(null);

      setSignupFormVal({
        nm: "",
        eml: "",
        phNo: "",
        city: "",
        state: "",
        submitedBy: "Individual",
        compName: "",
      });
    } else {
      setIsServerErr({
        ...isServerErr,
        isRejected: "Request failed, please try again after some time.",
      });
    }
  };

  const submitSignupForm = async (e) => {
    e.preventDefault();

    if (signupFormVal.submitedBy == "Individual") {
      await setSignupFormVal({ ...signupFormVal, compName: "" });
    }
    e.preventDefault();
    let Body = {
      nm: signupFormVal.nm,
      em: signupFormVal.eml,
      mob: signupFormVal.phNo,
      mod: signupFormVal.submitedBy === "Individual" ? "Client" : "Partner",
      rtg: 0,
      opt: signupFormVal.city,
      cmmt:
        signupFormVal.submitedBy === "Individual"
          ? "Client requested a callback"
          : `Partner requested a callback , company name - ${signupFormVal.compName}`,
      dev: getDevice(),
      pg: "Home page",
      url: config.url,
      ptf: "API connect",
      imgs: [],
      brw: fnBrowserDetect(),
      accode: "Guest User",
    };
    signFormSubmit(submitSignupFormRes, Body);
  };

  function onChangeSignupForm(key, value) {
    // onchange of any field remove both type of errors
    if (key === "city") {
      // separate city and state (state is blank string if not present in the value)
      const [city, state = ""] = value.split(";");
      setSignupFormVal({ ...signupFormVal, city, state });

      // if city length is greater than 2, then call the api with debounce of 300ms
      if (city.length > 2) {
        debounce(() => getCities(value), 300)();
      }
    } else {
      if (
        (key === "nm" && !alphabetExp.test(value)) ||
        (key === "phNo" && !integerExp.test(value))
      ) {
        value = signupFormVal[key];
      }

      setSignupFormVal({ ...signupFormVal, [key]: value });
    }
    setSignupErr({ ...signupErr, [key]: "" });

    return value;
  }

  function getCities(srchStr) {
    AGetCities(getCitiesRes, srchStr);
  }

  function getCitiesRes(res) {
    if (res.data && res.data.ctyLst) {
      setCities(res.data.ctyLst);
    }
  }

  function handleACBlur(value) {
    if (value.split(";").length !== 2) {
      setSignupErr({
        ...signupErr,
        city: "Please enter your city",
      });
    }
  }

  const showFaq = (id) => {
    if (faqs.faqId === id) {
      setFaqs({
        ...faqs,
        faqId: "",
      });
    } else {
      setFaqs({
        ...faqs,
        faqId: id,
      });
    }
  };

  const getResoucesRes = (res) => {
    if (res && res.data) {
      setResouces({
        articles: res.data.articles ? res.data.articles : [],
        videos: res.data.videos ? res.data.videos : [],
      });
    }
  };

  useEffect(() => {
    getFaqs(getFaqsRes);
    // getResouces(getResoucesRes);
    const body = {
      article: { pageDate: "", pageLimit: constants.Article, tag: [] },
      video: { pageDate: "", pageLimit: constants.Video, tag: [] },
    };
    getResoucesContent(getResoucesRes, body);
  }, []);

  const removeIsServerErrors = () => {
    setIsServerErr({
      isSuccess: "",
      isRejected: "",
    });
  };

  useEffect(() => {
    if (isServerErr.isSuccess !== "" || isServerErr.isRejected !== "") {
      removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
    }
  }, [isServerErr]);

  return (
    <>
      <div className="">
        <div className="homeWrap ">
          {/* banner */}
          <div className="bannerWrap ">
            <div className="container">
              <div className="bannerWrap-content">
                <div className="bannerWrap-content__wrap common-head-para">
                  <div>
                    <h2>Nuvama API Connect</h2>
                    <p>
                      <span>
                        Build, integrate and trade with our comprehensive
                      </span>
                      <span>suite of RESTful APIs and mobile SDKs</span>
                    </p>
                    <div className="bannerWrap-content__wrap_mob">
                      <p>Build, integrate and trade with our</p>
                      <p>comprehensive suite of RESTful</p>
                      <p>APIs and mobile SDKs</p>
                    </div>
                  </div>
                  {/* <div>
                    <a href="https://www.youtube.com/watch?v=CaVnFbgqSYg">
                      <div className="circle-border"></div>
                      <div>
                        <p className="">How it works?</p>
                      </div>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          {/* take control of your trading */}
          <div className="tradingControl container">
            <div className="tradingControl-img">
              <img src={controlTrade} alt="control trading" />
            </div>
            <div className="common-head-para tradingControl-text">
              <div>
                <h2>Take Control of Your Trading</h2>
                <p>
                  Track, trade & analyze with swift execution across all major
                  exchanges in varied segments including Cash, FNO, Commodity,
                  Currency and Mutual Funds with our robust APIs
                </p>
                <div>
                  <Link to="/signup">Get Started</Link>
                </div>
              </div>
            </div>
          </div>
          {/* get free access  */}
          <GetAccess
            title={GetAccecssTitle.HOME_TITLE}
            GetAccessData={GetAccessHome}
          />
          {/* trade in a language of your choice */}
          <div className="tradeLang container  ">
            <div className="display-flex-center">
              <div>
                <p className="smallText greyText">
                  Trade in a language of your choice
                </p>
                <ul className="display-flex">
                  <li>
                    <a
                      href={urlConfig.python_language}
                      target="_blank"
                      rel="noreferrer"
                    >
                    <img className="python" src={python} />
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={urlConfig.java_language}
                    >
                      <img className="java" src={java} ></img>  
                    </a>
                  </li>

                  <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={urlConfig.node_language}
                    >
                      <img className="node" src={node} ></img>  
                    </a>
                  </li>
                  {/* <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={urlConfig.c_language}
                    >
                      C#
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          {/* startup and fintech offerings */}
          <div className="learnTrade container ">
            <div className="learnTrade-img_mob">
              <img src={learnTrade} alt="learn trading" />
            </div>
            <div>
              <OfferSection Offers={Offers} title={OfferTitle.HOME_TITLE} />

              <div>
                <button className="text_btn">
                  <Link to="/signup">Request For Access</Link>
                </button>
              </div>
            </div>
            <div>
              <div className="learnTrade-img_destop">
                <img src={learnTrade} alt="learn trading" />
              </div>
            </div>
          </div>

          {/* learn about trading with algos */}
          <div className="tradingAlgos">
            <div className="container">
              {resouces &&
                resouces.videos &&
                resouces.videos.map((video) => {
                  return video.ishighlighted === true ? (
                    <VideoBanner video={video} />
                  ) : null;
                })}

              <div>
                <div className="custom-row articleVideoWrap articalVedio_row">
                  <div className="grid_item_1 ">
                    <div className="article">
                      <div>
                        <h5>Articles</h5>
                      </div>
                      <div className="article_section_wrap">
                        {resouces &&
                          resouces.articles &&
                          resouces.articles.map((article) => {
                            return (
                              <Article
                                key={article.resourceId}
                                article={article}
                              />
                            );
                          })}
                      </div>
                      <div>
                        <button className="text_btn">
                          <Link to="/articles">View All Articles</Link>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="grid_item_2">
                    <div className="article videos">
                      <div>
                        <h5>Videos</h5>
                      </div>
                      <div className="article_section_wrap">
                        <div className="videoWraps">
                          {resouces &&
                            resouces.videos &&
                            resouces.videos.map((video) => {
                              return video.ishighlighted !== true ? (
                                <Video key={video.resourceId} video={video} />
                              ) : null;
                            })}
                        </div>
                      </div>
                      <div>
                        <button className="text_btn">
                          <Link to="/videos">View All Videos</Link>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* faqs */}
          <div className="faqsWrap">
            <div className="faqs container">
              <h2 className="common-subHead">Frequently Asked Questions</h2>
              <div class="panel-group" id="accordion">
                {faqs.faqData !== ""
                  ? faqs.faqData.map((faq) => {
                      return (
                        <div
                          key={faq.id}
                          className="panel panel-default pointer"
                          onClick={() => showFaq(faq.id)}
                        >
                          <div
                            className="panel-heading "
                            role="tab"
                            id="headingThree"
                          >
                            <div className="panel-title ">
                              {faqs.faqId === faq.id ? (
                                <i className="edel-icon-minus"></i>
                              ) : (
                                <i className="edel-icon-plus"></i>
                              )}
                              <h5>{faq.question}</h5>
                            </div>
                          </div>
                          <div
                            id={
                              faqs.faqId === faq.id
                                ? "show_modal"
                                : "hide_modal"
                            }
                            class="panel-collapse collapse"
                          >
                            <div class="panel-body">
                              <p
                                dangerouslySetInnerHTML={{ __html: faq.answer }}
                              ></p>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
              <div className="showAllLink text_btn">
                <Link to="/support">Show all</Link>
              </div>
            </div>
          </div>
          {/* have more question for us? - form */}
          <div className="askQuesForm">
            <div className="container">
              {/* <div className="custom-row"> */}
              <div className="custom-grid">
                {/* <div className="custom-col info-col"> */}
                <div className=" info-col">
                  <div className="info-col-wrap">
                    <div className="form-heading">
                      <h2>Have more </h2>
                      <h2> questions for us?</h2>
                    </div>
                    <p>Lets us give you a call</p>
                  </div>
                </div>
                {/* <div className="custom-col form--col"> */}
                <div className=" form--col">
                  <form>
                    <div class="form-group">
                      <label for="nm" className="input-label">
                        Name
                      </label>
                      <InputField
                        pattern={betweenNChars(3)}
                        onChange={(value) => onChangeSignupForm("nm", value)}
                        onBlur={(error) =>
                          setSignupErr({
                            ...signupErr,
                            nm: error.pattern
                              ? ""
                              : "Please enter at least 3 character",
                          })
                        }
                        defaultValue={signupFormVal.nm}
                        className="login_inp mg-b40"
                        placeholder="Eg: Name Surname"
                        errorText={signupErr.nm}
                      />
                    </div>
                    <div class="form-group">
                      <label for="eml" className="input-label">
                        Email id
                      </label>
                      <InputField
                        class="form-control"
                        id="name"
                        aria-describedby="nameField"
                        placeholder="Eg: example@email.com"
                        pattern={emailRegex}
                        onChange={(value) => onChangeSignupForm("eml", value)}
                        onBlur={(error) =>
                          setSignupErr({
                            ...signupErr,
                            eml: error.pattern
                              ? ""
                              : "Please enter a valid email id",
                          })
                        }
                        defaultValue={signupFormVal.eml}
                        className="login_inp mg-b40"
                        errorText={signupErr.eml}
                      />
                    </div>
                    <div class="form-group">
                      <label for="phNo" className="input-label">
                        Mobile Number
                      </label>
                      <InputField
                        type="tel"
                        pattern={phoneNo}
                        onChange={(value) => onChangeSignupForm("phNo", value)}
                        onBlur={(error) =>
                          setSignupErr({
                            ...signupErr,
                            phNo: error.pattern
                              ? ""
                              : "Please enter a valid phone number",
                          })
                        }
                        defaultValue={signupFormVal.phNo}
                        className="login_inp mg-b30"
                        placeholder="Eg: 980908XXXX"
                        errorText={signupErr.phNo}
                      />
                    </div>
                    <div class="form-group">
                      <label for="city" className="input-label">
                        City
                      </label>
                      <Autocomplete
                        data={
                          cities
                            ? cities.map((city) => ({
                                value: city.city + ";" + city.state,
                                display: city.city,
                              }))
                            : null
                        }
                        onOptionSelect={(value) =>
                          onChangeSignupForm("city", value.value)
                        }
                        noDataMsg="City with similar name not found"
                        onChange={(value) => onChangeSignupForm("city", value)}
                        inputClassName="login_inp mg-b40"
                        placeholder="Eg: Mumbai"
                        onBlur={handleACBlur}
                        name="city"
                        defaultValue={signupFormVal.city}
                        className="city"
                      />
                    </div>
                    {signupFormVal.submitedBy === "Partner" && (
                      <div class="form-group">
                        <label for="compName" className="input-label">
                          Company Name
                        </label>
                        <InputField
                          pattern={betweenNChars(3)}
                          onChange={(value) =>
                            onChangeSignupForm("compName", value)
                          }
                          onBlur={(error) =>
                            setSignupErr({
                              ...signupErr,
                              compName: error.pattern
                                ? ""
                                : "Please enter at least 3   character",
                            })
                          }
                          defaultValue={signupFormVal.compName}
                          className="login_inp mg-b40"
                          placeholder="Eg: Example Pvt. Ltd."
                          errorText={signupErr.compName}
                        />
                      </div>
                    )}
                    <div>
                      <div
                        className="custom_radio"
                        onChange={(e) =>
                          setSignupFormVal({
                            ...signupFormVal,
                            submitedBy: e.target.value,
                          })
                        }
                      >
                        <div className="radioBtn">
                          <input
                            type="radio"
                            id="test1"
                            name="radio-group"
                            value="Individual"
                            checked={signupFormVal.submitedBy === "Individual"}
                          />
                          <label for="test1">
                            <p>Individual</p>
                          </label>
                        </div>
                        <div className="radioBtn">
                          <input
                            type="radio"
                            id="test2"
                            name="radio-group"
                            value="Partner"
                          />
                          <label for="test2">
                            <p>Partner</p>
                          </label>
                        </div>
                      </div>
                    </div>
                    {isServerErr.isSuccess !== "" && (
                      <div className="server_responce">
                        <span className=" green">{isServerErr.isSuccess} </span>
                      </div>
                    )}
                    {isServerErr.isRejected !== "" && (
                      <div className="server_responce">
                        <span className=" red">{isServerErr.isRejected} </span>
                      </div>
                    )}
                    <div>
                      <button
                        onClick={submitSignupForm}
                        className="btn white-btn"
                        disabled={
                          Object.values(signupErr).every((error) => error) ||
                          Object.values(signupFormVal).some((value) => !value)
                          // props.disableForm
                        }
                      >
                        Request A Call
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* footer */}
          <Footer />
          {!authContext.isAuth ? (
            <div className="mob_footer">
              <div className="home_footer">
                <Link to="/signup" className="btn">
                  Sign-up
                </Link>
                <Link to="/login" className="border-btn">
                  Login
                </Link>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};
export default Home;
